(() => {
  const element = document.getElementById('DaisyPurchaseConfig');
  if (!element) return;
  const config = JSON.parse(element.textContent);
  // Visual QA only: this does not enable checkout or bypass the launch gate.
  const previewWallet = config.draftTheme && new URLSearchParams(location.search).get('wallet_design_preview') === '1';
  const previewPurchase = config.draftTheme && new URLSearchParams(location.search).get('purchase_preview') === '1';
  const emailOfferVisitor = () => {
    if ((new URLSearchParams(location.search).get('offer') || '').toLowerCase() === 'restock26') return true;
    try { return localStorage.getItem('daisy:restock26:email-visitor') === '1'; }
    catch (_) { return false; }
  };
  const launchAt = Date.parse(config.launchAt);
  let serverTime = Number(config.renderedAt), sampledAt = performance.now(), verified = false;
  const variants = new Map((config.variants || []).map(variant => [String(variant.id), variant]));
  const selectedForms = new WeakSet();
  const scopeFor = form => form.closest('.fdp-buy') || form.closest('[id^="FigmaEcomm-"]') || form;
  const promptColor = form => {
    const scope = scopeFor(form);
    const swatches = scope.querySelector('.fdp-color-selector') || scope.querySelector('[data-color]')?.parentElement;
    let error = scope.querySelector('[data-color-error]');
    if (!error) {
      error = document.createElement('p');
      error.dataset.colorError = '';
      error.setAttribute('role', 'alert');
      error.textContent = 'please select a color';
      error.style.cssText = `position:absolute;left:0;top:${swatches.offsetTop + swatches.offsetHeight + 5}px;margin:0;font:14px/1.2 Arial,sans-serif;color:#000`;
      swatches.insertAdjacentElement('afterend',error);
    }
    error.hidden = false;
    scope.querySelector('[data-fdp-color],[data-color]')?.focus({preventScroll:true});
  };
  const now = () => serverTime + performance.now() - sampledAt;
  const open = () => (previewPurchase || (verified && now() >= launchAt)) && config.country === 'US' && config.currency === 'USD';
  const variantFor = form => variants.get(form.querySelector('[name="id"]')?.value);
  const allowed = form => open() && variantFor(form)?.available === true;
  const discountVisitorFor = form => emailOfferVisitor() || window.DaisySignupOffer?.usesCartCheckout() || window.DaisyRestockOffer?.discountedPrice(Number(variantFor(form)?.price)) != null;
  const refresh = () => {
    document.querySelectorAll('form[data-daisy-purchase]').forEach(form => {
      const variant = variantFor(form);
      const enabled = allowed(form);
      scopeFor(form).setAttribute('data-daisy-sale-open', String(enabled));
      const button = form.querySelector('[name="add"]');
      if (button) {
        button.disabled = !enabled;
        button.setAttribute('aria-disabled', String(!enabled));
        const label = button.querySelector('span') || button;
        label.textContent = config.country !== 'US' ? 'U.S. shipping only' : enabled ? 'add to bag' : 'sold out';
      }
      const wallet = form.querySelector('[data-daisy-wallet]');
      if (wallet) {
        // Email visitors use the cart flow; native product wallets can bypass discounts.
        const discountVisitor = discountVisitorFor(form);
        const walletEnabled = enabled;
        wallet.inert = !walletEnabled;
        wallet.style.visibility = enabled || previewWallet ? 'visible' : 'hidden';
        wallet.setAttribute('aria-disabled', String(!walletEnabled));
        let guard = wallet.querySelector('[data-daisy-color-guard]');
        if (!guard) {
          guard = document.createElement('button');
          guard.type = 'button';
          guard.dataset.daisyColorGuard = '';
          guard.setAttribute('aria-label', 'Select a color before express checkout');
          guard.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;z-index:5;background:transparent;border:0;padding:0;cursor:pointer';
          guard.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            if (!allowed(form)) { refresh(); return; }
            if (!selectedForms.has(form)) { promptColor(form); return; }
            if (discountVisitorFor(form)) {
              const add = form.querySelector('[name="add"]');
              if (add && !add.disabled && add.getAttribute('aria-disabled') !== 'true') form.requestSubmit(add);
            }
          });
          wallet.append(guard);
        }
        guard.hidden = selectedForms.has(form) && !discountVisitor;
        const guardLabel = selectedForms.has(form)
          ? 'Add to bag to use Apple Pay at checkout'
          : 'Select a color before express checkout';
        guard.setAttribute('aria-label', guardLabel);
        guard.title = guardLabel;
        const paymentButton = wallet.querySelector('.shopify-payment-button');
        if (paymentButton) paymentButton.inert = !walletEnabled || !selectedForms.has(form) || discountVisitor;
        const checkout = wallet.querySelector('shopify-accelerated-checkout');
        if (checkout && variant) checkout.setAttribute('variant-id', String(variant.id));
      }
      const scope = form.closest('.fdp-buy') || form;
      const amount = variant ? window.DaisyRestockOffer?.discountedPrice(Number(variant.price)) ?? Number(variant.price) : null;
      scope.querySelectorAll('[data-daisy-installment]').forEach(label => {
        if (amount == null) return;
        label.textContent = new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(amount / 400);
      });
    });
  };
  // Server Date avoids using a customer's incorrectly set clock to open sales.
  let syncing = false;
  const sync = async () => {
    if (syncing) return;
    syncing = true;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(`${config.root}cart.js?daisy_launch=${Date.now()}`, {cache:'no-store',credentials:'same-origin',signal:controller.signal});
      const date = Date.parse(response.headers.get('date'));
      if (!response.ok || !Number.isFinite(date)) throw new Error('Unable to verify server time');
      serverTime = date; sampledAt = performance.now(); verified = true;
      if (previewPurchase || date >= launchAt) {
        const result = await fetch(`${config.root}products/daisy-one.js?daisy_inventory=${date}`, {cache:'no-store',signal:controller.signal});
        if (result.ok) {const product = await result.json();product.variants.forEach(variant => variants.set(String(variant.id),variant));}
      }
      refresh();
    } catch (_) { /* Keep the prelaunch controls closed until server time is known. */ }
    finally {clearTimeout(timeout);syncing = false;}
  };
  window.DaisyPurchase = {refresh};
  const chooseColor = event => {
    const swatch = event.target.closest('[data-fdp-color],[data-color]');
    if (!swatch) return;
    const scope = swatch.closest('.fdp-buy') || swatch.closest('[id^="FigmaEcomm-"]');
    const form = scope?.querySelector('form[data-daisy-purchase]');
    if (!form) return;
    selectedForms.add(form);
    const error = scope.querySelector('[data-color-error]');
    if (error) error.hidden = true;
    refresh();
  };
  document.addEventListener('click', chooseColor, true);
  document.addEventListener('pointerdown', chooseColor, true);
  document.addEventListener('change', event => {if(event.target.matches('form[data-daisy-purchase] [name="id"]')) refresh();});
  document.addEventListener('daisy:restock-offer-ready', refresh);
  document.addEventListener('submit', event => {
    if (event.target.matches('form[data-daisy-purchase]') && !allowed(event.target)) {
      event.preventDefault(); event.stopImmediatePropagation(); refresh();
    }
  }, true);
  window.addEventListener('pageshow', sync);
  document.addEventListener('visibilitychange', () => {if(!document.hidden) sync();});
  let wasOpen = false;
  setInterval(() => {
    const isOpen = open();
    if (isOpen !== wasOpen) {wasOpen=isOpen;refresh();if(isOpen) sync();}
    if (!document.hidden && (!verified || (now() < launchAt && launchAt-now() < 60000))) sync();
  }, 1000);
  refresh(); sync();
})();
